import axios from 'axios';
import { API_BASE_URL } from './api.config';

// Public axios instance WITHOUT authentication (for products, categories, etc.)
export const publicRequest = axios.create({
  baseURL: API_BASE_URL,
});

// Authenticated axios instance WITH auth token (for user-specific requests)
export const authRequest = axios.create({
  baseURL: API_BASE_URL,
});

// Add a request interceptor to include the auth token for authenticated requests
authRequest.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('kacha_bazar_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle errors for authenticated requests
authRequest.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle 401 - Unauthorized (token expired or invalid)
    if (error.response?.status === 401) {
      // Clear auth data
      localStorage.removeItem('kacha_bazar_token');
      localStorage.removeItem('kacha_bazar_user');
      localStorage.removeItem('kacha_bazar_email');
      localStorage.removeItem('kacha_bazar_role');
      // Redirect to login if not already there
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }

    // Handle 403 - Forbidden (user doesn't have permission)
    // Don't redirect, just let the component handle it

    return Promise.reject(error);
  }
);

// Default export is authRequest for backward compatibility
export default authRequest;
